import { render, staticRenderFns } from "./InputDocument.vue?vue&type=template&id=2beda4c8&"
import script from "./InputDocument.vue?vue&type=script&lang=js&"
export * from "./InputDocument.vue?vue&type=script&lang=js&"
import style0 from "./InputDocument.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InputDocument.vue"
export default component.exports